
import '../App.css';
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { submitGetInTouchForm } from "./Email.js"
import { Navigate, useNavigate } from 'react-router-dom';
import { db } from '../config';
import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style
import "@fontsource/inter"; // Defaults to weight 400
import "@fontsource/inter/400.css"; // Specify weight
import "@fontsource/inter/400-italic.css"; // Specify weight and style
import "@fontsource/plus-jakarta-sans"; // Defaults to weight 400
import "@fontsource/plus-jakarta-sans/400.css"; // Specify weight
import "@fontsource/plus-jakarta-sans/400-italic.css"; // Specify weight and style
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/inter/800.css";
import "@fontsource/open-sans/500.css";
import "@fontsource/open-sans/600.css";
import "@fontsource/open-sans/700.css";
import "@fontsource/open-sans/800.css";
import "@fontsource/plus-jakarta-sans/500.css";
import "@fontsource/plus-jakarta-sans/600.css";
import "@fontsource/plus-jakarta-sans/700.css";
import "@fontsource/plus-jakarta-sans/800.css";

import waiting from '../loading.json'


import moment from 'moment/moment';
import { FaUserFriends } from "react-icons/fa";
import DatePicker from "react-datepicker";
import { FaUserTie } from "react-icons/fa";
import ReactModal from 'react-modal';
import { toast } from 'wc-toast'
import Select, { components } from 'react-select';
import { IoIosCloseCircle } from "react-icons/io";
import { decrypt, encrypt } from '../Crypto';
import { Button, Typography } from '@mui/material';
import BG1 from "../bg1.jpg";
import BG from "../home1.jpeg";
import LOGO from "../logo_new.png";
import { MdGroupAdd } from "react-icons/md";
import { MdOutlineGroupAdd } from "react-icons/md";
import { MdOutlineLocationOn } from "react-icons/md";
import { IoPersonAddOutline } from "react-icons/io5";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import { IoIosLink } from "react-icons/io";
import { LuLink } from "react-icons/lu";
import Lottie from 'lottie-react';
//import { ToastContainer, toast } from 'react-toastify';
//import 'react-toastify/dist/ReactToastify.css';

const userdb = db.ref('userdb');

const devices_db = db.ref('devices');
const customerdb = db.ref('customerdb');

const height = window.innerHeight;
const width = window.innerWidth;
//console.log(height)
//console.log(width)

// ✅ Best way for React web: import images (more stable than require)
function Home() {
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);

    const navigate = useNavigate();


    useEffect(() => {
        const onResize = () => {
            setScreenWidth(window.innerWidth);
            setScreenHeight(window.innerHeight);
        };
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    const isMobile = screenWidth <= 924;

    //////////////////// 1st part

    // ✅ scale based on the actual HERO width (no hard caps)
    const scale = (n) => {
        const heroPx = isMobile ? screenWidth : screenWidth * 0.97; // hero is 95% on desktop
        const DESIGN_W = 1832; // only used as a ratio reference (not a cap)

        const raw = heroPx / DESIGN_W;

        // keep it premium (avoid too small / too huge)
        const s = Math.max(0.85, Math.min(1.15, raw));

        return Math.round(n * s);
    };

    // ✅ white spacing around hero (top = sides)
    const pagePad = isMobile ? 14 : Math.max(18, Math.min(44, screenWidth * 0.022));

    // ✅ figma ratio (only ratio, not fixed px)
    const FIGMA_W = 1832;
    const FIGMA_H = 1004;
    const FIGMA_RATIO = FIGMA_H / FIGMA_W; // ≈ 0.548

    // ✅ Desktop width is % (no max), Mobile is 95%
    const heroW = isMobile ? "97%" : `${Math.round(95)}%`;

    // ✅ Hero pixel width (needed for height calc + scaling)
    const heroWpx = isMobile
        ? Math.round(screenWidth * 0.97)
        : Math.round(screenWidth * 0.97);

    // ✅ keep same ratio for height on desktop, safe min-height on mobile
    const heroMinH = isMobile
        ? Math.max(640, Math.round(screenHeight * 0.82))
        : Math.round(heroWpx * FIGMA_RATIO);

    // ✅ inner padding inside hero (also controls bottom-right spacing of cards)
    const heroInset = isMobile ? 14 : 22;

    const headerRowH = isMobile ? 56 : 70;


    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [activeNav, setActiveNav] = useState(null);

    const navItems = useMemo(
        () => ["HOME", "PHOTO GALLERY", "LEAGUE INFO", "CONTACT"],
        []
    );


    //////////


    const [activeNav1, setActiveNav1] = useState(null);

    const navItems1 = useMemo(
        () => ["MEMBERSHIP", "LEAGUE & COMMUNITY", "SAFEGUARDING POLICY"],
        []
    );

    ////////////////////// 2nd part

    // ✅ put this near your other consts inside Home()
    const sectionW = Math.round(screenWidth * 0.94);
    const aboutImg = require("../about2.jpg"); // ✅ replace with your actual image

    const ballImg = require("../ball2.jpg"); // ✅ replace with your actual image

    const welcome = require("../right.png"); // ✅ replace with your actual image

    const welcome1 = require("../welcome2.png"); // ✅ replace with your actual image

    //////////
    const g1 = require("../n10.jpeg");
    const g2 = require("../n9.jpeg");
    const g3 = require("../o4.jpeg");
    const g4 = require("../o5.jpeg");
    const g5 = require("../o6.jpeg");
    const g6 = require("../o7.jpeg");
    //  const g7 = require("../n2.jpeg");
    const g8 = require("../o8.jpg");

    const m1 = require("../m5.png");

    const m2 = require("../m2.png");

    const m3 = require("../m3.png");

    const n8 = require("../n8.jpeg");

    const n11 = require("../n11.jpg");

    const n12 = require("../n15.jpeg");

    const n13 = require("../n13.jpeg");

    const n16 = require("../n16.jpg");


    function smoothScrollTo(container, targetY, duration = 1200) {
        const startY = container === window ? window.scrollY : container.scrollTop;
        const startTime = performance.now();

        function easeInOutCubic(t) {
            return t < 0.5
                ? 4 * t * t * t
                : 1 - Math.pow(-2 * t + 2, 3) / 2;
        }

        function animate(currentTime) {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);
            const eased = easeInOutCubic(progress);

            const currentY = startY + (targetY - startY) * eased;

            if (container === window) {
                window.scrollTo(0, currentY);
            } else {
                container.scrollTop = currentY;
            }

            if (progress < 1) {
                requestAnimationFrame(animate);
            }
        }

        requestAnimationFrame(animate);
    }


    const homeRef = useRef(null);


    const scrollTohome = () => {
        const y =
            homeRef.current.getBoundingClientRect().top +
            window.scrollY -
            50; // header offset

        smoothScrollTo(window, y, 2000);
    };

    const photoRef = useRef(null);


    const scrollTophoto = () => {
        const y =
            photoRef.current.getBoundingClientRect().top +
            window.scrollY -
            50; // header offset

        smoothScrollTo(window, y, 2000);
    };


    const infoRef = useRef(null);


    const scrollToinfo = () => {
        const y =
            infoRef.current.getBoundingClientRect().top +
            window.scrollY -
            50; // header offset

        smoothScrollTo(window, y, 2000);
    };


    const contactRef = useRef(null);


    const scrollToContact = () => {
        const y =
            contactRef.current.getBoundingClientRect().top +
            window.scrollY -
            50; // header offset

        smoothScrollTo(window, y, 2000);
    };



    useEffect(() => {
        if (activeNav === "PHOTO GALLERY") {
            scrollTophoto(); // your slow smooth scroll
        }

        if (activeNav === "CONTACT") {
            scrollToContact();
        }

        if (activeNav === "HOME") {
            scrollTohome();
        }

        if (activeNav === "LEAGUE INFO") {
            scrollToinfo();
        }

    }, [activeNav]);



    useEffect(() => {
        if (activeNav1 === "MEMBERSHIP") {
            navigate('/Membership')
        }

        if (activeNav1 === "LEAGUE & COMMUNITY") {
            window.open(
                "https://wscsmba.co.uk/competitions/winter-league/",
                "_blank",
                "noopener,noreferrer"
            )
        }




    }, [activeNav1]);



    /* =========================
✅ COPY/PASTE (BEFORE RETURN) — GET IN TOUCH
Red borders + clear on type + auto scroll + focus first invalid
========================= */

    const [load, setLoad] = useState(false);

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [s_name, setS_name] = useState("");
    const [msg, setMsg] = useState("");

    // ✅ NEW: errors for this form (separate from membership)
    const [errors2, setErrors2] = useState({});

    // ✅ NEW: refs for scroll + focus (separate from membership)
    const fieldRefs2 = useRef({});
    const setFieldRef2 = (key) => (el) => {
        if (el) fieldRefs2.current[key] = el;
    };

    // order of focus
    const fieldOrder2 = ["name", "s_name", "email", "msg"];

    const focusFirstError2 = (nextErrors) => {
        const firstKey = fieldOrder2.find((k) => nextErrors?.[k]);
        if (!firstKey) return;

        requestAnimationFrame(() => {
            const el = fieldRefs2.current[firstKey];
            if (!el) return;

            try {
                el.scrollIntoView?.({ behavior: "smooth", block: "center" });
            } catch (e) { }

            try {
                el.focus?.({ preventScroll: true });
            } catch (e) { }
        });
    };

    // ✅ helper: updates value + clears red border when fixed
    const setField2 = (key, setter) => (e) => {
        const v = e.target.value;
        setter(v);

        setErrors2((prev) => {
            if (!prev?.[key]) return prev;
            return { ...prev, [key]: false };
        });
    };

    // ✅ validate + set errors + focus first
    const validateGetInTouch = () => {
        const next = {
            name: !name.trim(),
            s_name: !s_name.trim(),
            email: !email.trim(),
            msg: !msg.trim(),
        };

        setErrors2(next);

        const ok = !Object.values(next).some(Boolean);
        if (!ok) focusFirstError2(next);

        return ok;
    };

    // Get in touch submit
    async function onSubmitGetInTouch(e) {
        const ok = validateGetInTouch();

        if (!ok) {
            toast.error("Please fill up all required info");
            setLoad(false);
            return;
        }

        setLoad(true);
        try {
            await submitGetInTouchForm({
                to: "alanbythesea@outlook.com",
                firstName: name,
                lastName: s_name,
                email: email,
                message: msg,
            });

            toast.success("Your message has been sent");
            setLoad(false);

            // reset fields
            setName("");
            setEmail("");
            setS_name("");
            setMsg("");

            // ✅ clear red borders after success
            setErrors2({});
        } catch (err) {
            alert(err.message);
            setLoad(false);
        }
    }







    const pressDown = (e) => {
        e.currentTarget.style.transform = "scale(0.98)";
    };

    const pressUp = (e) => {
        e.currentTarget.style.transform = "scale(1)";
        e.currentTarget.style.background = "rgba(255,255,255,0.12)";
    };

    const hoverIn = (e) => {
        e.currentTarget.style.background = "rgba(255,255,255,0.16)";
    };
    const hoverIn1 = (e) => {
        e.currentTarget.style.background = "#2a9bc6";
    };
    const hoverIn2 = (e) => {
        e.currentTarget.style.background = "#206B8A";
    };

    const hoverOut = (e) => {
        e.currentTarget.style.background = "transparent";
    };


    const hoverOut2 = (e) => {
        e.currentTarget.style.background = "#2a9bc6";
    };


    const hoverOut3 = (e) => {
        e.currentTarget.style.background = "transparent";
    };



    const hoverOut4 = (e) => {
        e.currentTarget.style.background = "#2A8FB8";
    };

    const hoverOut1 = (e) => {
        e.currentTarget.style.background = "rgba(42,155,198,0.88)";
    };



    return (
        <div
            style={{
                // minHeight: "100dvh",
                width: screenWidth,
                background: "#FFFFFF",
                boxSizing: "border-box",

                // ✅ equal white space all around + safe-area
                // paddingTop: `calc(${pagePad}px + env(safe-area-inset-top))`,
                paddingBottom: `calc(${pagePad}px + env(safe-area-inset-bottom))`,
                paddingLeft: `calc(${pagePad}px + env(safe-area-inset-left))`,
                paddingRight: `calc(${pagePad}px + env(safe-area-inset-right))`,

                display: "flex",
                justifyContent: 'flex-start',
                alignItems: "flex-start",
                flexDirection: 'column'
            }}
        >
            <div style={{ width: screenWidth, display: "flex", justifyContent: "center", alignSelf: 'center' }}>

                {/* ✅ HERO CARD */}
                <div
                    ref={homeRef}
                    style={{
                        width: screenWidth, // "95%" on both (as you set)
                        minHeight: heroMinH, // ✅ fixes mobile white screen + desktop ratio height
                        height: "auto", // ✅ let it be driven by minHeight + content
                        // borderRadius: 22,
                        overflow: "hidden",
                        position: "relative",
                        background: "#000",
                        boxShadow: "0 18px 60px rgba(0,0,0,0.18)",
                    }}
                >
                    {/* ✅ Background image (absolute) */}
                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            backgroundImage: `url(${BG})`,
                            backgroundSize: "cover",
                            backgroundPosition: isMobile ? "75% center" : "20% top",
                            backgroundRepeat: "no-repeat",
                            transform: "scale(1.02)",
                            filter: "saturate(1.05) contrast(1.05)",
                        }}
                    />
                    {/* ✅ overlay for text readability */}
                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            background: "linear-gradient(90deg, rgba(0,0,0,0.72) 0%, rgba(0,0,0,0.42) 55%, rgba(0,0,0,0.22) 100%)",
                        }}
                    />

                    {/* ✅ CONTENT (NOT absolute — so mobile height works) */}
                    <div
                        style={{
                            position: "relative",
                            zIndex: 2,
                            padding: heroInset,
                            boxSizing: "border-box",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {/* TOP NAV */}
                        <div
                            style={{
                                height: headerRowH,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: scale(14),
                            }}
                        >
                            {/* Left: logo + hamburger */}
                            <div style={{ display: "flex", alignItems: "center", gap: scale(12) }}>
                                <div

                                    style={{
                                        width: isMobile ? 44 : 90,
                                        height: isMobile ? 44 : 90,
                                        borderRadius: 999,
                                        background: "rgba(255,255,255,0.08)",
                                        backdropFilter: "blur(10px)",
                                        display: "grid",
                                        placeItems: "center",
                                        border: "1px solid rgba(255,255,255,0.14)",
                                        overflow: "hidden",
                                        flexShrink: 0,
                                    }}
                                >
                                    <img
                                        src={LOGO}
                                        alt="Logo"
                                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                    />
                                </div>

                                {isMobile ? (
                                    <div
                                        onClick={() => setMobileMenuOpen((v) => !v)}
                                        style={{
                                            width: 44,
                                            height: 44,
                                            borderRadius: 12,
                                            background: "rgba(0,0,0,0.28)",
                                            border: "1px solid rgba(255,255,255,0.14)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            userSelect: "none",
                                            backdropFilter: "blur(10px)",
                                        }}
                                    >
                                        <div style={{ display: "grid", gap: 5 }}>
                                            <div style={{ width: 18, height: 2, background: "rgba(255,255,255,0.9)", borderRadius: 99 }} />
                                            <div style={{ width: 18, height: 2, background: "rgba(255,255,255,0.9)", borderRadius: 99 }} />
                                            <div style={{ width: 18, height: 2, background: "rgba(255,255,255,0.9)", borderRadius: 99 }} />
                                        </div>
                                    </div>
                                ) : null}
                            </div>

                            {/* Center nav (desktop only) */}
                            {!isMobile ? (
                                <div style={{ display: "flex", alignItems: "center", gap: scale(12) }}>
                                    {navItems.map((t) => {
                                        let active = t === activeNav;
                                        if (t == "HOME" && activeNav == null) {
                                            active = true
                                        }
                                        return (
                                            <div
                                                key={t}
                                                onClick={() => setActiveNav(t)}
                                                style={{
                                                    padding: `${scale(10)}px ${scale(14)}px`,
                                                    borderRadius: 10,
                                                    fontSize: 24,
                                                    color: active ? "#000000" : "#FFFFFF",
                                                    background: active ? "#2B8EB8" : "transparent",
                                                    fontWeight: 500,
                                                    fontFamily: "Plus Jakarta Sans",
                                                    cursor: "pointer",
                                                    userSelect: "none",
                                                    letterSpacing: 0.3,
                                                    transition: "0.2s",
                                                }}
                                                onMouseEnter={(e) => {
                                                    if (!active) e.currentTarget.style.background = "rgba(42,155,198,0.88)";
                                                }}
                                                onMouseLeave={(e) => {
                                                    if (!active) e.currentTarget.style.background = "transparent";
                                                }}
                                            >
                                                {t}
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div />
                            )}

                            {/* Membership */}
                            <button

                                onClick={() => navigate('/Membership')}
                                style={{
                                    border: "none",
                                    cursor: "pointer",
                                    padding: `${scale(12)}px ${scale(18)}px`,
                                    borderRadius: 12,
                                    background: "#206B8A",
                                    color: "white",
                                    fontWeight: 500,
                                    letterSpacing: 0.3,
                                    boxShadow: "0 12px 24px rgba(0,0,0,0.25)",
                                    fontSize: isMobile ? 14 : 24,
                                    whiteSpace: "nowrap",
                                    fontFamily: "Plus Jakarta Sans",
                                }}


                                onMouseDown={pressDown}
                                onMouseUp={pressUp}
                                onMouseEnter={hoverIn2}
                                onMouseLeave={hoverOut1}
                                onTouchStart={pressDown}
                                onTouchEnd={pressUp}
                            >
                                MEMBERSHIP
                            </button>
                        </div>

                        {/* Mobile dropdown menu */}
                        {isMobile && mobileMenuOpen ? (
                            <div
                                style={{
                                    marginTop: 12,
                                    width: "92%",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    background: "rgba(0,0,0,0.45)",
                                    border: "1px solid rgba(255,255,255,0.14)",
                                    borderRadius: 16,
                                    padding: 10,
                                    backdropFilter: "blur(12px)",
                                    boxShadow: "0 18px 50px rgba(0,0,0,0.35)",
                                }}
                            >
                                {navItems.map((t) => (
                                    <div
                                        key={t}
                                        onClick={() => {
                                            setActiveNav(t);
                                            setMobileMenuOpen(false);
                                        }}
                                        style={{
                                            padding: "12px 12px",
                                            borderRadius: 12,
                                            color: "rgba(255,255,255,0.92)",
                                            fontWeight: 700,
                                            cursor: "pointer",
                                            fontSize: 16,
                                            background: t === activeNav ? "rgba(42,155,198,0.30)" : "transparent",
                                        }}
                                    >
                                        {t}
                                    </div>
                                ))}
                            </div>
                        ) : null}

                        {/* HERO BODY */}
                        <div style={{ flex: 1, display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1.35fr 0.65fr", gap: isMobile ? 18 : 28 }}>
                            {/* LEFT (middle on desktop) */}
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: isMobile ? "flex-start" : "center",
                                    alignItems: "flex-start",
                                    paddingLeft: isMobile ? 0 : 12,
                                }}
                            >
                                <div
                                    style={{
                                        fontSize: isMobile ? 32 : 64,
                                        lineHeight: isMobile ? "39px" : "81px",
                                        fontWeight: 700,
                                        color: "#fff",
                                        letterSpacing: -0.6,
                                        //  fontFamily: "Plus Jakarta Sans",
                                        fontfamily: "Plus Jakarta Sans",
                                        textAlign: 'left',
                                        marginTop: isMobile ? 20 : null
                                    }}
                                >
                                    Witterings{" "}
                                    <span style={{ color: "#BDDCE9", fontWeight: 700 }}>Short Mat</span>
                                    <br />
                                    <span style={{ color: "#BDDCE9", fontWeight: 700 }}>Bowls{" "}</span>
                                    Club
                                </div>

                                <div
                                    style={{
                                        marginTop: 14,
                                        fontSize: isMobile ? 14 : 24,
                                        lineHeight: isMobile ? "22px" : "40px",
                                        color: "rgba(255,255,255,0.92)",
                                        maxWidth: isMobile ? "100%" : 640,
                                        textAlign: 'left',
                                        fontFamily: "Plus Jakarta Sans",
                                        fontWeight: 400
                                    }}
                                >
                                    Join a welcoming community where short mat bowls is played for enjoyment,
                                    friendship, and friendly competition.
                                </div>

                                <div

                                    style={{ display: "flex", gap: 14, flexWrap: "wrap", marginTop: 28 }}>
                                    <button
                                        onClick={() => navigate('/Membership')}
                                        style={{
                                            border: "none",
                                            cursor: "pointer",
                                            padding: "12px 30px",
                                            borderRadius: 10,
                                            background: "#2a9bc6",
                                            color: "#0b0f14",
                                            fontWeight: 400,
                                            fontSize: isMobile ? 16 : 24,
                                            minWidth: isMobile ? "60%" : 200,
                                            // fontfamily: "Inter"
                                            fontFamily: "Plus Jakarta Sans",
                                            // fontfamily: "Plus Jakarta Sans",


                                        }}


                                        onMouseDown={pressDown}
                                        onMouseUp={pressUp}
                                        onMouseEnter={hoverIn2}
                                        onMouseLeave={hoverOut2}
                                        onTouchStart={pressDown}
                                        onTouchEnd={pressUp}
                                    >

                                        <AiOutlineUsergroupAdd size={isMobile ? 15 : 23} color="#000000" /> Join the Club
                                    </button>

                                    <button
                                        onClick={() => window.open(
                                            "https://www.google.com/maps?client=safari&hs=jlKp&sca_esv=e8bb71c9cc7ce2dd&rls=en&sxsrf=ANbL-n4SheUY7jU70QbSDAX2jOpKjfa39Q:1770839237649&biw=1440&bih=819&uact=5&gs_lp=Egxnd3Mtd2l6LXNlcnAiPFRoZSBWaWxsYWdlIEhhbGwgLCBSb29rd29vZCBSb2FkICwgV2VzdCBXaXR0ZXJpbmcgLCBQTzIwIDhMVDIFECEYoAEyBRAhGKABMgUQIRigAUi0C1CfBFiDCXADeACQAQCYAYwBoAHIAaoBAzEuMbgBA8gBAPgBAvgBAZgCBKACuQHCAggQABiABBiwA8ICDhAAGIAEGIoFGIYDGLADwgILEAAYiQUYogQYsAPCAgsQABiABBiiBBiwA5gDAIgGAZAGCJIHAzMuMaAH6ASyBwMwLjG4B50BwgcFMi0zLjHIBxeACAE&um=1&ie=UTF-8&fb=1&gl=uk&sa=X&geocode=KS1ne43pUHRIMeBwPcMlwayh&daddr=Elms+Ln,+West+Wittering,+Chichester+PO20+8LW",
                                            "_blank",
                                            "noopener,noreferrer"
                                        )}
                                        style={{
                                            cursor: "pointer",
                                            padding: "12px 18px",
                                            borderRadius: 10,
                                            background: "transparent",
                                            color: "rgba(255,255,255,0.92)",
                                            fontWeight: 400,
                                            border: "1.5px solid rgba(42,155,198,0.8)",
                                            fontSize: isMobile ? 16 : 24,
                                            minWidth: isMobile ? "60%" : 180,
                                            backdropFilter: "blur(10px)",
                                            fontFamily: "Plus Jakarta Sans",

                                        }}


                                        onMouseDown={pressDown}
                                        onMouseUp={pressUp}
                                        onMouseEnter={hoverIn2}
                                        onMouseLeave={hoverOut3}
                                        onTouchStart={pressDown}
                                        onTouchEnd={pressUp}
                                    >

                                        <MdOutlineLocationOn size={isMobile ? 14 : 21} color="rgba(255,255,255,0.92)" /> Visit Us
                                    </button>


                                </div>
                            </div>

                            {/* RIGHT (bottom on desktop) */}
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: isMobile ? "flex-start" : "flex-end",
                                    alignItems: "flex-end",
                                    gap: 16,
                                    paddingBottom: isMobile ? 0 : heroInset,
                                }}
                            >

                                <div
                                    style={{
                                        width: isMobile ? "min(300px, 90%)" : 360,
                                        backgroundColor: 'transparent',

                                        position: "relative",

                                        //  boxShadow: "0 18px 40px rgba(0,0,0,0.38)",
                                    }}
                                >

                                    <img
                                        src={welcome1}

                                        style={{
                                            width: "100%",
                                            // height: isMobile ? 240 : 560,   // ✅ gives a real box to center within
                                            objectFit: "cover",             // ✅ not fill
                                            //  objectPosition: "center",        // ✅ centered crop
                                            display: "block",
                                        }}
                                    />

                                </div>
                            </div>
                        </div>

                        {isMobile ? <div style={{ height: 10 }} /> : null}
                    </div>
                </div>
            </div>

            <div
                style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    //   background: "#05080C",
                    paddingTop: isMobile ? 28 : 56,
                    paddingBottom: isMobile ? 38 : 70,
                    boxSizing: "border-box",
                }}
            >
                {/* ✅ content width must be 0.94 * screenWidth */}
                <div
                    style={{
                        width: sectionW,
                        maxWidth: sectionW, // keep exact
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        gap: isMobile ? 22 : 54,
                        alignItems: isMobile ? "stretch" : "center",
                        boxSizing: "border-box",
                    }}
                >
                    {/* ✅ LEFT IMAGE FRAME */}

                    {/* ✅ LEFT IMAGE FRAME (matches Figma look) */}

                    <div
                        style={{
                            flex: isMobile ? "unset" : "0 0 52%",
                            position: "relative",
                            borderRadius: isMobile ? 18 : 26,
                            // background: "#DCEFF7",

                            // ✅ this is what actually centers the inner card
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",

                            // ✅ frame thickness (space around the inner card)
                            padding: isMobile ? 12 : 18,
                        }}
                    >
                        {/* ✅ inner card (controls image size + keeps it centered) */}
                        <div
                            style={{
                                width: "100%",
                                //  maxWidth: isMobile ? "100%" : 740, // tune if you want
                                borderRadius: isMobile ? 14 : 20,
                                //  overflow: "hidden",
                                background: "#DCEFF7",
                                border: "4px solid #DFEEF4",
                                // boxShadow: "0 18px 40px rgba(0,0,0,0.28)",
                                display: 'flex',
                                justifyContent: 'center',
                                alignContent: 'center',
                                alignItems: 'center'
                            }}
                        >
                            <img
                                src={n12}
                                alt="About the Club"
                                style={{
                                    width: "100%",
                                    // height: isMobile ? 240 : 560,   // ✅ gives a real box to center within
                                    objectFit: "cover",             // ✅ not fill
                                    //  objectPosition: "center",        // ✅ centered crop
                                    display: "block",
                                    borderRadius: isMobile ? 14 : 20,
                                }}
                            />
                        </div>
                    </div>


                    {/* ✅ RIGHT TEXT */}

                    {/* ✅ RIGHT TEXT CONTENT (matches your screenshot) */}


                    <div
                        style={{
                            flex: isMobile ? "unset" : "0 0 44%",
                            paddingLeft: isMobile ? 0 : 12,
                            paddingTop: isMobile ? 18 : 10,

                            /* ✅ ADD THESE */
                            maxWidth: isMobile ? "100%" : 640,
                            paddingRight: isMobile ? 0 : 100,

                            fontFamily: "Plus Jakarta Sans",
                            //  backgroundColor: 'red'
                        }}
                    >


                        {/* Small heading */}
                        <div
                            style={{
                                fontSize: isMobile ? 16 : 24,
                                fontWeight: 700,
                                color: "#206B8A", // teal like screenshot
                                marginBottom: 8,
                                fontFamily: "Plus Jakarta Sans",
                                textAlign: 'left'
                            }}
                        >
                            About the Club
                        </div>

                        {/* Big title */}
                        <div
                            style={{
                                fontSize: isMobile ? 34 : 40,
                                lineHeight: isMobile ? "40px" : "52px",
                                fontWeight: 700,
                                color: "#080D1A", // very dark navy like screenshot
                                letterSpacing: -0.6,
                                fontFamily: "Plus Jakarta Sans",
                                textAlign: 'left',

                                paddingRight: isMobile ? 0 : 20,
                            }}
                        >
                            More Than Just A Sport
                        </div>

                        {/* Yellow underline bar */}
                        <div
                            style={{
                                marginTop: 16,
                                width: 92,
                                height: 6,
                                borderRadius: 999,
                                background: "#FBBF24", // yellow/amber like screenshot
                                fontFamily: "Plus Jakarta Sans",
                            }}
                        />

                        {/* Paragraphs */}


                        <div style={{
                            marginTop: 26, fontSize: isMobile ? 15 : 20, lineHeight: isMobile ? "26px" : "30px", color: "#354153", // grey-blue like screenshot 
                            fontWeight: 400, maxWidth: "clamp(480px, 42vw, 600px)",


                            /* ✅ ensure space on the right */
                            paddingRight: isMobile ? 0 : 70,

                            /* ✅ prevents text from touching next column */
                            marginRight: "auto",

                            fontFamily: "Plus Jakarta Sans",
                            textAlign: "left",
                        }} >
                            West Wittering Short Mat Bowls Club is at the heart of our local community. We believe that sport brings people together, and our club is built on the foundations of friendship, fair play, and fun.
                        </div>


                        < div
                            style={{
                                marginTop: 22,
                                fontSize: isMobile ? 15 : 20,
                                lineHeight: isMobile ? "26px" : "30px",
                                color: "#354153",
                                fontWeight: 400,

                                /* ✅ responsive width control */
                                //  maxWidth: isMobile ? "100%" : 560,
                                maxWidth: "clamp(480px, 42vw, 600px)",


                                /* ✅ ensure space on the right */
                                paddingRight: isMobile ? 0 : 70,

                                /* ✅ prevents text from touching next column */
                                marginRight: "auto",

                                fontFamily: "Plus Jakarta Sans",
                                textAlign: "left",
                            }}
                        >
                            We play in the Village Hall, which provides a comfortable and spacious
                            environment year-round. While we take pride in our competitive achievements,
                            our main focus is creating a social space where members can relax, chat over
                            a cup of tea, and enjoy the game.
                        </div>


                        {/* Stats row */}
                        <div
                            style={{
                                display: "flex",
                                gap: isMobile ? 22 : 44,
                                alignItems: "flex-end",
                                marginTop: isMobile ? 28 : 34,
                                flexWrap: "wrap",
                                fontFamily: "Plus Jakarta Sans",
                            }}
                        >

                            {/* Year-Round */}
                            <div style={{ display: "flex", gap: 14, alignItems: "flex-end", fontFamily: "Plus Jakarta Sans" }}>
                                <div
                                    style={{
                                        width: 3,
                                        height: 56,
                                        borderRadius: 999,
                                        background: "#FBBF24", // yellow line like screenshot
                                        fontFamily: "Plus Jakarta Sans",
                                    }}
                                />
                                <div style={{ fontFamily: "Plus Jakarta Sans" }}>
                                    <div
                                        style={{
                                            fontSize: 34,
                                            lineHeight: "36px",
                                            fontWeight: 700,
                                            color: "#FBBF24",
                                            letterSpacing: -0.4,
                                            fontFamily: "Plus Jakarta Sans",

                                            paddingRight: isMobile ? 0 : 20,
                                        }}
                                    >
                                        Year-Round
                                    </div>
                                    <div
                                        style={{
                                            marginTop: 4,
                                            fontSize: 14,
                                            color: "rgba(53,65,83,0.70)",
                                            fontWeight: 600,
                                            fontFamily: "Plus Jakarta Sans",
                                            textAlign: 'left'
                                        }}
                                    >
                                        Indoor Play
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
            </div>

            {/* ✅ SECTION: When We Meet (below Hero Card) */}
            <div
                style={{
                    width: isMobile ? "95%" : Math.round(screenWidth * 0.93), // ✅ 0.94 * screenWidth
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: isMobile ? 18 : 26,
                    borderRadius: isMobile ? 18 : 22,
                    background: "#EAF6FB",
                    padding: isMobile ? 18 : 34,
                    boxSizing: "border-box",
                    fontFamily: "Plus Jakarta Sans",
                }}
            >
                {/* Title */}
                <div
                    style={{
                        textAlign: "center",
                        fontSize: isMobile ? 30 : 40,
                        fontWeight: 700,
                        letterSpacing: -0.6,
                        color: "#0F172A",
                        fontFamily: "Plus Jakarta Sans",
                    }}
                >
                    When <span style={{ color: "#2389B6", fontFamily: "Plus Jakarta Sans" }}>We Meet</span>
                </div>

                {/* Subtitle */}
                <div
                    style={{
                        marginTop: 10,
                        textAlign: "center",
                        fontSize: isMobile ? 14 : 16,
                        lineHeight: isMobile ? "22px" : "24px",
                        color: "#45556C",
                        maxWidth: 780,
                        marginLeft: "auto",
                        marginRight: "auto",
                        fontFamily: "Plus Jakarta Sans",
                        fontWeight: 400
                    }}
                >
                    Join us at the West Wittering Village Hall. We play twice a week, with sessions for
                    casual play and league practice.
                </div>

                {/* Cards row */}
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: isMobile ? "1fr" : "repeat(2, 1fr)",
                        gap: isMobile ? 14 : 26,
                        marginTop: isMobile ? 18 : 26,
                        alignItems: "stretch",
                        fontFamily: "Plus Jakarta Sans",
                    }}
                >
                    {[
                        { tag: "CLUB ROLL-UP", title: "Tuesday Afternoon", time: "2:00 PM – 4:30 PM" },
                        { tag: "CLUB ROLL-UP", title: "Thursday Morning", time: "10:00 AM – 1:00 PM" },
                    ].map((c) => (
                        <div
                            key={c.title}
                            style={{
                                background: "#FFFFFF",
                                borderRadius: 16,
                                border: "1px solid rgba(2,6,23,0.10)",
                                boxShadow: "0 2px 0 rgba(2,6,23,0.05)",
                                padding: isMobile ? 16 : 20,
                                minHeight: isMobile ? 110 : 126,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "space-between",
                                fontFamily: "Plus Jakarta Sans",
                            }}
                        >
                            {/* Top row: icon + badge */}
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "flex-start",
                                    justifyContent: "space-between",
                                    gap: 14,
                                    fontFamily: "Plus Jakarta Sans",
                                }}
                            >
                                {/* Icon chip (matches screenshot: pale blue square) */}
                                <div
                                    style={{
                                        width: 48,
                                        height: 48,
                                        borderRadius: 12,
                                        background: "#EAF6FF",
                                        display: "grid",
                                        placeItems: "center",
                                        flexShrink: 0,
                                        fontFamily: "Plus Jakarta Sans",
                                    }}
                                >
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                        <rect x="4.8" y="6.2" width="14.4" height="13.4" rx="3" stroke="#0F172A" strokeWidth="1.6" />
                                        <path d="M8 4.6V7.6" stroke="#0F172A" strokeWidth="1.6" strokeLinecap="round" />
                                        <path d="M16 4.6V7.6" stroke="#0F172A" strokeWidth="1.6" strokeLinecap="round" />
                                        <path d="M5 9.4H19" stroke="#0F172A" strokeWidth="1.6" strokeLinecap="round" />
                                    </svg>
                                </div>

                                {/* Badge (small pill, very light orange bg) */}
                                <div
                                    style={{
                                        padding: "6px 12px",
                                        borderRadius: 999,
                                        background: "rgba(245,158,11,0.12)",
                                        color: "#B45309",
                                        fontWeight: 600,
                                        fontSize: 12,
                                        letterSpacing: 0.5,
                                        whiteSpace: "nowrap",
                                        fontFamily: "Plus Jakarta Sans",
                                    }}
                                >
                                    {c.tag}
                                </div>
                            </div>

                            {/* Middle: title */}
                            <div
                                style={{
                                    marginTop: 14,
                                    fontSize: isMobile ? 22 : 24,
                                    fontWeight: 700,
                                    color: "#0F172A",
                                    letterSpacing: -0.4,
                                    fontFamily: "Plus Jakarta Sans",
                                    textAlign: 'left'
                                }}
                            >
                                {c.title}
                            </div>

                            {/* Bottom: time row (clock + text) */}
                            <div
                                style={{
                                    marginTop: 10,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 10,
                                    color: "rgba(15,23,42,0.70)",
                                    fontSize: 16,
                                    fontFamily: "Plus Jakarta Sans",
                                    fontWeight: 400
                                }}
                            >
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path
                                        d="M12 22a10 10 0 1 0-10-10 10 10 0 0 0 10 10Z"
                                        stroke="rgba(15,23,42,0.55)"
                                        strokeWidth="1.6"
                                    />
                                    <path
                                        d="M12 7v6l4 2"
                                        stroke="rgba(15,23,42,0.55)"
                                        strokeWidth="1.6"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                {c.time}
                            </div>
                        </div>
                    ))}
                </div>


                {/* Footer note */}
                <div
                    style={{
                        textAlign: "center",
                        marginTop: isMobile ? 18 : 22,
                        fontSize: 14,
                        color: "rgba(15,23,42,0.55)",
                        fontStyle: "italic",
                        fontFamily: "Plus Jakarta Sans",
                        fontWeight: 400
                    }}
                >
                    * Please arrive 15 minutes before the start time for team selection.
                </div>
            </div>

            {/* PHOTO GALLERY HEADER (below cards row) */}
            <div
                ref={photoRef}
                style={{
                    width: isMobile ? "95%" : Math.round(screenWidth * 0.94),
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: isMobile ? 35 : 45,
                    textAlign: "center",
                    fontFamily: "Plus Jakarta Sans",
                }}
            >
                <div
                    style={{
                        fontSize: isMobile ? 30 : 44,
                        fontWeight: 700,
                        letterSpacing: -0.6,
                        lineHeight: 1.05,
                        color: "#0B1220",
                        fontFamily: "Plus Jakarta Sans",
                    }}
                >
                    Photo{" "}
                    <span style={{ color: "#2a9bc6", fontFamily: "Plus Jakarta Sans" }}>
                        Gallery
                    </span>
                </div>

                <div
                    style={{
                        marginTop: 10,
                        fontSize: isMobile ? 14 : 16,
                        lineHeight: "22px",
                        color: "rgba(15,23,42,0.70)",
                        fontFamily: "Plus Jakarta Sans",
                    }}
                >
                    Moments of friendship, competition, and community spirit.
                </div>
            </div>

            {/* PHOTO GALLERY GRID (below header) */}
            <div
                style={{
                    width: isMobile ? "95%" : Math.round(screenWidth * 0.94),
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: isMobile ? 18 : 26,
                    fontFamily: "Plus Jakarta Sans",
                }}
            >
                <div
                    style={{
                        display: "grid",
                        gap: isMobile ? 12 : 18,
                        //  gridTemplateColumns: isMobile ? "1fr" : "1.2fr 1.6fr 1.2fr",
                        gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr 1fr",

                        alignItems: "stretch",
                    }}
                >
                    {/* LEFT BIG */}
                    <div
                        style={{
                            borderRadius: isMobile ? 14 : 18,
                            overflow: "hidden",
                            background: "#BDDCE9",
                            boxShadow: "0 18px 50px rgba(0,0,0,0.20)",
                            border: "4px solid #BDDCE9",
                        }}
                    >
                        <img
                            src={n13}
                            alt="Gallery 1"
                            style={{
                                width: "100%",
                                height: isMobile ? 300 : "100%",
                                minHeight: isMobile ? 300 : 520,
                                objectFit: "cover",
                                display: "block",
                            }}
                        />
                    </div>

                    {/* CENTER BIG */}
                    <div
                        style={{
                            borderRadius: isMobile ? 14 : 18,
                            overflow: "hidden",
                            background: "#BDDCE9",
                            boxShadow: "0 18px 50px rgba(0,0,0,0.20)",
                            border: "4px solid #BDDCE9",
                        }}
                    >
                        <img
                            src={g2}
                            alt="Gallery 2"
                            style={{
                                width: "100%",
                                height: isMobile ? 300 : "100%",
                                minHeight: isMobile ? 300 : 520,
                                objectFit: 'cover',
                                display: "block",
                            }}
                        />
                    </div>





                    {/* RIGHT STACK */}

                    {/* RIGHT STACK (ONLY 2 ROWS / 4 IMAGES, SAME HEIGHT) */}
                    <div
                        style={{
                            display: "grid",
                            gap: isMobile ? 12 : 18,

                            // ✅ 2 rows only
                            gridTemplateRows: isMobile ? "auto auto" : "1fr 1fr",

                            // ✅ make this column stretch to the same height as the big cards
                            height: "100%",
                            alignItems: "stretch",
                        }}
                    >
                        {/* Row 1 (2 images) */}
                        <div
                            style={{
                                display: "grid",
                                gap: isMobile ? 12 : 18,
                                gridTemplateColumns: "1fr 1fr",
                                height: isMobile ? "auto" : "100%",
                                alignItems: "stretch",
                            }}
                        >
                            {[g3, g5].map((src, i) => (
                                <div
                                    key={`r1-${i}`}
                                    style={{
                                        borderRadius: isMobile ? 14 : 18,
                                        overflow: "hidden",
                                        background: "#BDDCE9",
                                        boxShadow: "0 18px 50px rgba(0,0,0,0.20)",
                                        border: "4px solid #BDDCE9",
                                    }}
                                >
                                    <img
                                        src={src}
                                        alt={`Gallery r1 ${i + 1}`}
                                        style={{
                                            width: "100%",
                                            height: isMobile ? 190 : "100%", // ✅ stretch on desktop
                                            objectFit: "cover",
                                            display: "block",
                                        }}
                                    />
                                </div>
                            ))}
                        </div>

                        {/* Row 2 (2 images) */}
                        <div
                            style={{
                                display: "grid",
                                gap: isMobile ? 12 : 18,
                                gridTemplateColumns: "1fr 1fr",
                                height: isMobile ? "auto" : "100%",
                                alignItems: "stretch",
                            }}
                        >
                            {[g4, g6].map((src, i) => (
                                <div
                                    key={`r2-${i}`}
                                    style={{
                                        borderRadius: isMobile ? 14 : 18,
                                        overflow: "hidden",
                                        background: "#BDDCE9",
                                        boxShadow: "0 18px 50px rgba(0,0,0,0.20)",
                                        border: "4px solid #BDDCE9",
                                    }}
                                >
                                    <img
                                        src={src}
                                        alt={`Gallery r2 ${i + 1}`}
                                        style={{
                                            width: "100%",
                                            height: isMobile ? 190 : "100%", // ✅ stretch on desktop
                                            objectFit: "cover",
                                            display: "block",
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>


                </div>
            </div>

            {/* ✅ EXTRA 4-IMAGE ROW (below PHOTO GALLERY GRID) */}
            <div
                style={{
                    width: isMobile ? "95%" : Math.round(screenWidth * 0.94),
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: isMobile ? 14 : 18,
                    fontFamily: "Plus Jakarta Sans",
                }}
            >
                <div
                    style={{
                        display: "grid",
                        gap: isMobile ? 12 : 18,
                        gridTemplateColumns: isMobile ? "1fr 1fr" : "repeat(4, 1fr)", // ✅ 4 in a row on desktop
                        alignItems: "stretch",
                    }}
                >
                    {[m1, m2, m3, n16].map((src, i) => (
                        <div
                            key={`extra-row-${i}`}
                            style={{
                                borderRadius: isMobile ? 14 : 18,
                                overflow: "hidden",
                                background: "#BDDCE9",
                                boxShadow: "0 18px 50px rgba(0,0,0,0.20)",
                                //  border: "4px solid #BDDCE9",
                            }}
                        >
                            <img
                                src={src}
                                alt={`Extra gallery ${i + 1}`}
                                style={{
                                    width: "100%",
                                    height: isMobile ? "100%" : "100%", // ✅ adjust if you want taller/shorter
                                    objectFit: 'fill',
                                    display: "block",
                                }}
                            />
                        </div>
                    ))}
                </div>
            </div>

            <div
                style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    //   background: "#05080C",
                    paddingTop: isMobile ? 28 : 56,
                    paddingBottom: isMobile ? 38 : 70,
                    boxSizing: "border-box",
                }}
            >
                {/* ✅ content width must be 0.94 * screenWidth */}
                <div
                    style={{
                        width: sectionW,
                        maxWidth: sectionW, // keep exact
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        gap: isMobile ? 22 : 54,
                        alignItems: isMobile ? "stretch" : "center",
                        boxSizing: "border-box",
                    }}
                >
                    {/* ✅ LEFT IMAGE FRAME */}

                    {/* ✅ LEFT IMAGE FRAME (matches Figma look) */}

                    <div
                        style={{
                            flex: isMobile ? "unset" : "0 0 52%",
                            position: "relative",
                            borderRadius: isMobile ? 18 : 26,
                            // background: "#DCEFF7",

                            // ✅ this is what actually centers the inner card
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",

                            // ✅ frame thickness (space around the inner card)
                            padding: isMobile ? 12 : 18,
                        }}
                    >
                        {/* ✅ inner card (controls image size + keeps it centered) */}
                        <div
                            style={{
                                width: "100%",
                                //  maxWidth: isMobile ? "100%" : 740, // tune if you want
                                borderRadius: isMobile ? 14 : 20,
                                //  overflow: "hidden",
                                background: "#DCEFF7",
                                border: "4px solid #DFEEF4",
                                // boxShadow: "0 18px 40px rgba(0,0,0,0.28)",
                                display: 'flex',
                                justifyContent: 'center',
                                alignContent: 'center',
                                alignItems: 'center'
                            }}
                        >
                            <img
                                src={n12}
                                alt="About the Club"
                                style={{
                                    width: "100%",
                                    // height: isMobile ? 240 : 560,   // ✅ gives a real box to center within
                                    objectFit: "cover",             // ✅ not fill
                                    //  objectPosition: "center",        // ✅ centered crop
                                    display: "block",

                                    borderRadius: isMobile ? 14 : 20,
                                }}
                            />
                        </div>
                    </div>


                    {/* ✅ RIGHT TEXT */}

                    {/* ✅ RIGHT TEXT CONTENT (matches your screenshot) */}
                    {/* ✅ RIGHT TEXT (League Info) – match screenshot */}
                    <div
                        ref={infoRef}
                        style={{
                            flex: isMobile ? "unset" : "0 0 44%",
                            paddingLeft: isMobile ? 0 : 12,
                            paddingTop: isMobile ? 18 : 10,
                            fontFamily: "Plus Jakarta Sans",
                            textAlign: "left",
                        }}
                    >
                        {/* Small heading */}
                        <div
                            style={{
                                fontSize: isMobile ? 16 : 22,
                                fontWeight: 700,
                                color: "#1E6A86",
                                marginBottom: 8,
                                fontFamily: "Plus Jakarta Sans",
                            }}
                        >
                            League Info
                        </div>

                        {/* Big title */}
                        <div
                            style={{
                                fontSize: isMobile ? 34 : 48,
                                lineHeight: isMobile ? "40px" : "56px",
                                fontWeight: 700,
                                color: "#0B1220",
                                letterSpacing: -0.8,
                                fontFamily: "Plus Jakarta Sans",
                            }}
                        >
                            League &amp; Competition
                        </div>


                        {/* Paragraph */}
                        <div
                            style={{
                                marginTop: 22,
                                fontSize: isMobile ? 14 : 18,
                                lineHeight: isMobile ? "26px" : "32px",
                                color: "rgba(11,18,32,0.68)",
                                fontWeight: 500,

                                /* ✅ better line length + right breathing room */
                                maxWidth: isMobile ? "100%" : 560,
                                paddingRight: isMobile ? 0 : 48,
                                marginRight: "auto",

                                fontFamily: "Plus Jakarta Sans",
                                textAlign: "left",
                            }}
                        >


                            We are affiliated to West Sussex County Short Mat Bowls Association (WSCSMBA) and play in division three. While we enjoy the competitive aspect of league play, we are keen to give all members the opportunity to be involved should they wish. Participation is entirely optional, with no pressure to compete — many members are happy to enjoy the social side of the game alone.

                            League matches and friendly matches are played throughout the winter season.

                            <br />
                            <br />
                            By clicking the link below, you can view our current position in the league table on the West Sussex Short Mat  Bowls Association website.

                        </div>

                        {/* Feature rows */}
                        <div
                            style={{
                                marginTop: isMobile ? 15 : 25,
                                display: "grid",
                                gap: isMobile ? 18 : 22,

                                /* ✅ keep feature list from touching right edge */
                                maxWidth: isMobile ? "100%" : 600,
                                paddingRight: isMobile ? 0 : 48,
                                marginRight: "auto",

                                fontFamily: "Plus Jakarta Sans",
                            }}
                        >


                            {/* Button row */}
                            <div
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    marginTop: 10,
                                    justifyContent: isMobile ? "center" : "flex-start",
                                }}
                            >
                                <button
                                    type="button"

                                    onClick={() => window.open(
                                        "https://wscsmba.co.uk/competitions/winter-league/",
                                        "_blank",
                                        "noopener,noreferrer"
                                    )}


                                    style={{
                                        border: "none",
                                        cursor: "pointer",
                                        paddingLeft: isMobile ? 22 : 28,
                                        paddingRight: isMobile ? 22 : 28,
                                        borderRadius: 10,
                                        background: "#2A8FB8",
                                        color: "#0B1220",
                                        fontWeight: 700,
                                        fontSize: isMobile ? 18 : 22,
                                        fontFamily: "Plus Jakarta Sans",
                                        height: isMobile ? 52 : 60,
                                        gap: 10,
                                        boxShadow: "0 14px 34px rgba(0,0,0,0.18)",
                                    }}


                                    onMouseDown={pressDown}
                                    onMouseUp={pressUp}
                                    onMouseEnter={hoverIn1}
                                    onMouseLeave={hoverOut4}
                                    onTouchStart={pressDown}
                                    onTouchEnd={pressUp}
                                >
                                    <LuLink size={isMobile ? 14 : 20} color="#000000" /> See More
                                </button>
                            </div>
                        </div>


                    </div>


                </div>
            </div>












            {/* ✅ NEXT PART: “Join one of our sessions” header (below League section) */}

            {/* ✅ NEXT PART: “Join one of our sessions” header + subtitle */}
            <div
                ref={contactRef}
                style={{
                    width: isMobile ? "94%" : Math.round(screenWidth * 0.94),
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: isMobile ? 34 : 24,
                    fontFamily: "Plus Jakarta Sans",
                    textAlign: "center",
                }}
            >
                <div
                    style={{
                        fontSize: isMobile ? 30 : 40,
                        lineHeight: isMobile ? "36px" : "58px",
                        fontWeight: 600,
                        letterSpacing: -0.6,
                        color: "#020202",
                        fontFamily: "Plus Jakarta Sans",
                    }}
                >
                    We'd love to hear from you. Give us a call or drop by during
                </div>

                <div
                    style={{
                        marginTop: isMobile ? 10 : 14,
                        fontSize: isMobile ? 30 : 40,
                        lineHeight: isMobile ? "36px" : "58px",
                        fontWeight: 600,
                        letterSpacing: -0.6,
                        color: "#2B8EB8",
                        fontFamily: "Plus Jakarta Sans",
                    }}
                >
                    one of our sessions.
                </div>
            </div>

            {/* ✅ CONTACT SECTION (below previous part) */}
            <div

                style={{
                    width: isMobile ? "92%" : Math.round(screenWidth * 0.92),
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: isMobile ? 34 : 56,
                    fontFamily: "Plus Jakarta Sans",
                    // backgroundColor: 'navy'
                }}
            >


                {/* Two column layout */}
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: isMobile ? "1fr" : "1fr 1.15fr",
                        gap: isMobile ? 18 : 28,
                        alignItems: "start",
                        fontFamily: "Plus Jakarta Sans",
                    }}
                >
                    {/* LEFT: Info cards */}

                    <div
                        style={{
                            display: "grid",
                            gap: isMobile ? 16 : 18,
                            fontFamily: "Plus Jakarta Sans",

                            // ✅ reduce card/column width from the RIGHT only
                            width: "100%",
                            maxWidth: isMobile ? "100%" : 630, // 🔥 change 520 to your desired width
                            marginRight: "auto",
                            // ✅ keeps LEFT fixed
                        }}
                    >


                        {/* Section title */}
                        <div
                            style={{
                                fontSize: isMobile ? 34 : 56,
                                fontWeight: 700,
                                letterSpacing: -0.8,
                                color: "#0B1220",
                                marginBottom: isMobile ? 18 : 22,
                                fontFamily: "Plus Jakarta Sans",
                                textAlign: "left",
                            }}
                        >
                            Contact Us
                        </div>

                        {[
                            {
                                iconBg: "#E7F3FB",
                                iconColor: "#0A74B8",
                                title: "Phone",
                                sub: "Chat with our Secretary, Alan",
                                value: "077 100 99 200",
                                icon: (
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                        <path
                                            d="M7.5 3.5h1.1c.7 0 1.3.5 1.5 1.2l.6 2.2c.2.6-.1 1.3-.6 1.7l-1 .8c1 1.9 2.6 3.5 4.5 4.5l.8-1c.4-.5 1.1-.8 1.7-.6l2.2.6c.7.2 1.2.8 1.2 1.5v1.1c0 1-.8 1.8-1.8 1.8C11 20.4 3.6 13 3.6 5.3c0-1 .8-1.8 1.8-1.8Z"
                                            stroke="currentColor"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                ),
                            },
                            {
                                iconBg: "#FFF3DB",
                                iconColor: "#D97706",
                                title: "Email",
                                sub: "Drop us a line anytime",
                                value: "alanbythesea@outlook.com",
                                icon: (
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                        <path
                                            d="M4.5 7.5A3 3 0 0 1 7.5 4.5h9A3 3 0 0 1 19.5 7.5v9a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-9Z"
                                            stroke="currentColor"
                                            strokeWidth="1.8"
                                        />
                                        <path
                                            d="m6.5 8.5 5 4 5-4"
                                            stroke="currentColor"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                ),
                            },
                            {
                                iconBg: "#EEF2F7",
                                iconColor: "#334155",
                                title: "Location",
                                sub: "Our playing venue",
                                value: "The Village Hall , Rookwood Road , West Wittering , PO20 8LT.",
                                icon: (
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                        <path
                                            d="M12 21s7-4.4 7-11a7 7 0 1 0-14 0c0 6.6 7 11 7 11Z"
                                            stroke="currentColor"
                                            strokeWidth="1.8"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M12 13.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Z"
                                            stroke="currentColor"
                                            strokeWidth="1.8"
                                        />
                                    </svg>
                                ),
                            },
                        ].map((x) => (
                            <div
                                key={x.title}
                                style={{
                                    background: "#fff",
                                    borderRadius: 18,
                                    border: "1px solid rgba(15,23,42,0.08)",
                                    boxShadow: "0 18px 50px rgba(15,23,42,0.08)",
                                    padding: isMobile ? 16 : 24,
                                    display: "flex",
                                    gap: 16,
                                    alignItems: "center",
                                    fontFamily: "Plus Jakarta Sans",
                                    textAlign: 'left'
                                }}
                            >
                                <div
                                    style={{
                                        width: 54,
                                        height: 54,
                                        borderRadius: 999,
                                        background: x.iconBg,
                                        display: "grid",
                                        placeItems: "center",
                                        color: x.iconColor,
                                        flexShrink: 0,
                                        fontFamily: "Plus Jakarta Sans",
                                    }}
                                >
                                    {x.icon}
                                </div>

                                <div style={{ fontFamily: "Plus Jakarta Sans" }}>
                                    <div
                                        style={{
                                            fontSize: 20,
                                            fontWeight: 700,
                                            color: "#0B1220",
                                            fontFamily: "Plus Jakarta Sans",
                                        }}
                                    >
                                        {x.title}
                                    </div>
                                    <div
                                        style={{
                                            marginTop: 2,
                                            fontSize: 14,
                                            color: "rgba(15,23,42,0.58)",
                                            fontFamily: "Plus Jakarta Sans",
                                        }}
                                    >
                                        {x.sub}
                                    </div>
                                    <div
                                        style={{
                                            marginTop: 6,
                                            fontSize: 20,
                                            fontWeight: 700,
                                            color: x.title === "Location" ? "rgba(15,23,42,0.80)" : "#0A74B8",
                                            letterSpacing: -0.2,
                                            fontFamily: "Plus Jakarta Sans",
                                            wordBreak: "break-word",
                                        }}
                                    >
                                        {x.value}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* RIGHT: Form card */}
                    {/* ✅ RIGHT: Form card (match screenshot exactly) */}


                    {/* ✅ RIGHT: Form card (mobile + desktop match) */}
                    <div
                        style={{
                            background: "#EAF6FB",
                            borderRadius: isMobile ? 22 : 28,
                            border: "1px solid rgba(15,23,42,0.08)",
                            boxShadow: "0 34px 90px rgba(0,0,0,0.22)",
                            padding: isMobile ? 18 : 30,
                            fontFamily: "Plus Jakarta Sans",
                            boxSizing: "border-box",
                            width: "100%",
                            maxWidth: "100%",
                        }}
                    >
                        {/* Title */}
                        <div
                            style={{
                                fontSize: isMobile ? 40 : 56,
                                fontWeight: 700,
                                letterSpacing: -0.8,
                                color: "rgba(15,23,42,0.62)",
                                fontFamily: "Plus Jakarta Sans",
                                lineHeight: isMobile ? "44px" : "60px",
                                textAlign: "left",
                            }}
                        >
                            Get in Touch
                        </div>

                        {/* ✅ helper: field block */}
                        {(() => {
                            const labelStyle = {
                                fontSize: 14,
                                letterSpacing: 1.4,
                                color: "rgba(15,23,42,0.58)",
                                fontWeight: 700,
                                marginBottom: 10,
                                fontFamily: "Plus Jakarta Sans",
                                textAlign: "left",
                                paddingLeft: 2,
                            };

                            const inputStyle = {
                                width: "100%",
                                height: 56,
                                borderRadius: 18,
                                border: "2px solid rgba(15,23,42,0.16)",
                                background: "#FFFFFF",
                                padding: "0 18px",
                                outline: "none",
                                fontSize: 18,
                                color: "rgba(15,23,42,0.72)",
                                fontFamily: "Plus Jakarta Sans",
                                boxSizing: "border-box",
                                boxShadow:
                                    "inset 0 1px 0 rgba(255,255,255,0.95), 0 10px 22px rgba(15,23,42,0.06)",
                            };

                            const textAreaStyle = {
                                width: "100%",
                                height: 170,
                                resize: "none",
                                borderRadius: 18,
                                border: "2px solid rgba(15,23,42,0.16)",
                                background: "#FFFFFF",
                                padding: "16px 18px",
                                outline: "none",
                                fontSize: 18,
                                lineHeight: "26px",
                                color: "rgba(15,23,42,0.72)",
                                fontFamily: "Plus Jakarta Sans",
                                boxSizing: "border-box",
                                boxShadow:
                                    "inset 0 1px 0 rgba(255,255,255,0.95), 0 10px 22px rgba(15,23,42,0.06)",
                            };

                            // ✅ red border (only changes border)
                            const errBorder = "2px solid #EF4444";

                            return (
                                <>
                                    {/* ✅ NAME + SURNAME row */}
                                    <div
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
                                            gap: isMobile ? 14 : 24,
                                            marginTop: isMobile ? 18 : 26,
                                            width: "100%",
                                            boxSizing: "border-box",
                                            fontFamily: "Plus Jakarta Sans",
                                        }}
                                    >
                                        {/* NAME */}
                                        <div style={{ width: "100%", fontFamily: "Plus Jakarta Sans" }}>
                                            <div style={labelStyle}>NAME</div>
                                            <input
                                                ref={setFieldRef2("name")}
                                                placeholder="John"
                                                value={name}
                                                onChange={setField2("name", setName)}
                                                style={{
                                                    ...inputStyle,
                                                    border: errors2?.name ? errBorder : inputStyle.border,
                                                }}
                                            />
                                        </div>

                                        {/* SURNAME */}
                                        <div style={{ width: "100%", fontFamily: "Plus Jakarta Sans" }}>
                                            <div style={labelStyle}>SURNAME</div>
                                            <input
                                                ref={setFieldRef2("s_name")}
                                                placeholder="Doe"
                                                value={s_name}
                                                onChange={setField2("s_name", setS_name)}
                                                style={{
                                                    ...inputStyle,
                                                    border: errors2?.s_name ? errBorder : inputStyle.border,
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/* MAIL */}
                                    <div
                                        style={{
                                            marginTop: isMobile ? 14 : 22,
                                            width: "100%",
                                            boxSizing: "border-box",
                                            fontFamily: "Plus Jakarta Sans",
                                        }}
                                    >
                                        <div style={labelStyle}>MAIL</div>
                                        <input
                                            ref={setFieldRef2("email")}
                                            placeholder="johndoe@mail.net"
                                            value={email}
                                            onChange={setField2("email", setEmail)}
                                            style={{
                                                ...inputStyle,
                                                border: errors2?.email ? errBorder : inputStyle.border,
                                            }}
                                        />
                                    </div>

                                    {/* MESSAGE */}
                                    <div
                                        style={{
                                            marginTop: isMobile ? 14 : 22,
                                            width: "100%",
                                            boxSizing: "border-box",
                                            fontFamily: "Plus Jakarta Sans",
                                        }}
                                    >
                                        <div style={labelStyle}>MESSAGE</div>
                                        <textarea
                                            ref={setFieldRef2("msg")}
                                            placeholder="Your message..."
                                            value={msg}
                                            onChange={setField2("msg", setMsg)}
                                            style={{
                                                ...textAreaStyle,
                                                border: errors2?.msg ? errBorder : textAreaStyle.border,
                                            }}
                                        />
                                    </div>

                                    {/* Button */}
                                    <button
                                        onClick={() => onSubmitGetInTouch()}
                                        style={{
                                            marginTop: isMobile ? 18 : 24,
                                            width: "100%",
                                            height: 72,
                                            border: "none",
                                            borderRadius: 16,
                                            background: "#2A8FB8",
                                            color: "#0B1220",
                                            fontSize: 20,
                                            fontWeight: 700,
                                            cursor: "pointer",
                                            fontFamily: "Plus Jakarta Sans",
                                            boxSizing: "border-box",
                                            boxShadow: "0 16px 34px rgba(0,0,0,0.22)",
                                        }}
                                        onMouseDown={pressDown}
                                        // onMouseUp={pressUp}
                                        onMouseEnter={hoverIn1}
                                        onMouseLeave={hoverOut4}
                                        onTouchStart={pressDown}
                                    // onTouchEnd={pressUp}
                                    >
                                        Send Message
                                    </button>
                                </>
                            );
                        })()}
                    </div>


                </div>
            </div>

            {/* FOOTER (Full width) */}
            <div

                style={{
                    width: screenWidth,
                    background: "#EAF6FB",
                    fontFamily: "Plus Jakarta Sans",
                    paddingTop: isMobile ? 26 : 44,
                    paddingBottom: isMobile ? 18 : 26,
                    alignSelf: 'center',
                    marginTop: isMobile ? 60 : 100,
                    marginBottom: isMobile ? -14 : -43

                }}
            >
                {/* inner container (keeps nice margins but footer bg is 100%) */}
                <div
                    style={{
                        width: "92%",
                        maxWidth: 1800,
                        margin: "0 auto",
                        display: "grid",
                        gridTemplateColumns: isMobile ? "1fr" : "1.25fr 0.9fr 0.9fr 1.1fr",
                        gap: isMobile ? 22 : 48,
                        alignItems: "start",
                    }}
                >
                    {/* Column 1: Brand */}
                    <div style={{ maxWidth: 420 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                            <div
                                style={{
                                    width: 34,
                                    height: 34,
                                    borderRadius: 999,
                                    overflow: "hidden",
                                    border: "2px solid rgba(42,155,198,0.45)",
                                    background: "rgba(255,255,255,0.6)",
                                    display: "grid",
                                    placeItems: "center",
                                    flexShrink: 0,
                                }}
                            >
                                <img
                                    src={LOGO}
                                    alt="Logo"
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                            </div>

                            <div style={{ fontSize: 20, fontWeight: 700, color: "#0B1220" }}>
                                West Wittering{" "}
                                <span style={{ color: "#0A74B8", fontWeight: 700 }}>SMBC</span>
                            </div>
                        </div>

                        <div
                            style={{
                                marginTop: 14,
                                fontSize: 14.5,
                                lineHeight: "22px",
                                color: "rgba(15,23,42,0.65)",
                                textAlign: 'left'
                            }}
                        >
                            A friendly, inclusive short mat bowls club in the heart of West Wittering.
                            We welcome players of all ages and abilities to join our community.
                        </div>
                    </div>

                    {/* Column 2: Explore */}
                    <div>
                        <div style={{ fontSize: 15, fontWeight: 700, color: "#0B1220", textAlign: 'left' }}>
                            Explore
                        </div>

                        <div style={{ marginTop: 14, display: "grid", gap: 10 }}>
                            {navItems.map((t) => (
                                <div
                                    key={t}

                                    onClick={() => {
                                        setActiveNav(t);
                                    }}

                                    style={{
                                        fontSize: 14.5,
                                        color: "rgba(15,23,42,0.62)",
                                        cursor: "pointer",
                                        width: "fit-content",
                                    }}
                                >
                                    {t}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Column 3: Pages */}
                    <div>
                        <div style={{ fontSize: 15, fontWeight: 700, color: "#0B1220", textAlign: 'left' }}>
                            Pages
                        </div>

                        <div style={{ marginTop: 14, display: "grid", gap: 10 }}>

                            {navItems1.map((t) => (
                                <div
                                    key={t}

                                    onClick={() => {
                                        setActiveNav1(t)
                                    }}

                                    style={{
                                        fontSize: 14.5,
                                        color: "rgba(15,23,42,0.62)",
                                        cursor: "pointer",
                                        width: "fit-content",
                                    }}
                                >
                                    {t}
                                </div>
                            )
                            )}
                        </div>
                    </div>

                    {/* Column 4: Visit Us */}
                    <div>
                        <div style={{ fontSize: 15, fontWeight: 700, color: "#0B1220", textAlign: 'left' }}>
                            Visit Us
                        </div>

                        <div
                            style={{
                                marginTop: 14,
                                fontSize: 14.5,
                                lineHeight: "22px",
                                color: "rgba(15,23,42,0.62)",
                                maxWidth: 360, textAlign: 'left'
                            }}
                        >
                            We're always happy to see new faces. Drop by for a chat and a cup of tea.
                        </div>

                        <div style={{ marginTop: 16, display: "grid", gap: 12 }}>
                            {/* Phone */}
                            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                                <div style={{ width: 18, height: 18, color: "#0A74B8" }}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                        <path
                                            d="M7.5 3.5h1.1c.7 0 1.3.5 1.5 1.2l.6 2.2c.2.6-.1 1.3-.6 1.7l-1 .8c1 1.9 2.6 3.5 4.5 4.5l.8-1c.4-.5 1.1-.8 1.7-.6l2.2.6c.7.2 1.2.8 1.2 1.5v1.1c0 1-.8 1.8-1.8 1.8C11 20.4 3.6 13 3.6 5.3c0-1 .8-1.8 1.8-1.8Z"
                                            stroke="currentColor"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>

                                <div style={{ color: "rgba(15,23,42,0.72)", fontSize: 14.5 }}>
                                    077 100 99 200
                                </div>
                            </div>

                            {/* Times */}
                            <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                                <div style={{ width: 18, height: 18, color: "#0A74B8", marginTop: 2 }}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                        <path
                                            d="M12 22a10 10 0 1 0-10-10 10 10 0 0 0 10 10Z"
                                            stroke="currentColor"
                                            strokeWidth="1.8"
                                        />
                                        <path
                                            d="M12 7v6l4 2"
                                            stroke="currentColor"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>

                                <div style={{ color: "rgba(15,23,42,0.72)", fontSize: 14.5, lineHeight: "22px", textAlign: 'left' }}>
                                    Tue: 2:00 PM - 4:30 PM
                                    <br />
                                    Thu: 10:00 AM - 01:00 PM
                                </div>
                            </div>

                            {/* Email */}
                            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                                <div style={{ width: 18, height: 18, color: "#0A74B8" }}>
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                        <path
                                            d="M4.5 7.5A3 3 0 0 1 7.5 4.5h9A3 3 0 0 1 19.5 7.5v9a3 3 0 0 1-3 3h-9a3 3 0 0 1-3-3v-9Z"
                                            stroke="currentColor"
                                            strokeWidth="1.8"
                                        />
                                        <path
                                            d="m6.5 8.5 5 4 5-4"
                                            stroke="currentColor"
                                            strokeWidth="1.8"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </div>

                                <div style={{ color: "rgba(15,23,42,0.72)", fontSize: 14.5 }}>
                                    alanbythesea@outlook.com
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {/* inner container (keeps nice margins but footer bg is 100%) */}
                <div
                    style={{
                        width: "92%",
                        maxWidth: 1800,
                        margin: "0 auto",
                        display: "grid",
                        gridTemplateColumns: isMobile ? "1fr" : "1.25fr 0.9fr 0.9fr 1.1fr",
                        gap: isMobile ? 22 : 48,
                        alignItems: "start",
                    }}
                >
                    {/* Column 1: Brand */}
                    <div style={{ maxWidth: 420 }}>
                        <div style={{
                            display: "flex", alignItems: "center",
                            color: "rgba(15,23,42,0.55)",
                            fontSize: 13.5, textAlign: 'left',
                            marginTop: isMobile ? 20 : 0
                        }}>

                            © 2026 West Wittering Short Mat Bowls Club. All rights reserved.


                        </div>

                    </div>

                    {/* Column 2: Explore */}
                    <div>
                        <div style={{
                            display: "flex", alignItems: "center",
                            color: "rgba(15,23,42,0.55)",
                            fontSize: 13.5, textAlign: 'left',
                            gap: 22,
                        }}>
                            {["Privacy", "Terms", "Cookies", "Version: 3.1"].map((t) => (
                                <div key={t} style={{ cursor: "pointer" }}>
                                    {t}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Column 3: Pages */}
                    <div>

                    </div>

                    {/* Column 4: Visit Us */}
                    <div>

                    </div>
                </div>


            </div>


            {
                load === true ? (
                    <Lottie
                        animationData={waiting}
                        loop
                        style={{
                            width: "min(500px, 80vw)",
                            height: "min(500px, 80vw)",
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 9999,
                            pointerEvents: "none",
                        }}
                    />
                ) : null
            }



        </div>
    );
}

export default Home;
